<ng-container *transloco="let t; read:'permit.photoCommentModal'">
    <div class="modal">
        <div class="modal__content">
            <div class="modal__content__details">
                <form [formGroup]="permitPhotosCommentForm">
                    <div class="modal__content__details__comment" *ngIf="data.modalType === 'comment'">
                        <div class="modal__content__details__comment__list" *ngIf="filteredComments$ | async as comments">
                            <pmt-permit-comments-comment *ngFor="let comment of getCommentsWithAvatarId(comments)" [comment]="comment"
                                    [canDelete]="(comments$ | async)?.currentUserIsIssuer">
                            </pmt-permit-comments-comment>
                        </div>
                        <label for="comment">{{ t("comment") }}</label>
                        <textarea id="comment" name="comment" #comment class="modal__content__comment" formControlName="comment" rows="5" enterkeyhint="done" [placeholder]="getPlaceholder()"></textarea>
                    </div>
                    <div class="modal__content__details__photo" *ngIf="data.modalType === 'photo'">
                        <div class="modal__content__details__photo__list" *ngIf="filteredPhotos$ | async as photos">
                            <div *ngFor="let photo of photos" class="modal__content__details__photo__list__item">
                                <img class="modal__content__details__photo__list__item__image" [src]="photo.url" alt="Photo" />
                                <button class="modal__content__details__photo__list__item__remove" (click)="removePhoto(photo.guid)">
                                    <p></p>
                                </button>
                            </div>
                        </div>
                        <input class="modal__content__details__photo__file-input" type="file" multiple #fileInput (change)="processSelectedImages(fileInput)" accept="image/*;capture=camera" />
                        <button (click)="fileInput.click()" class="modal__content__details__photo__upload-button" [loading]="savePermitPhotoAction">
                            {{t((filteredPhotos$ | async)?.length > 0 ? "addAdditionalPhoto" : "addPhoto") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="close()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!isValid" type="button" (click)="savePhotoOrComment()" [loading]="[savePermitPhotoAction, createCommentAction]">
                {{ t("create")}}
            </button>
        </div>
    </div>
</ng-container>
